import { Auth } from "aws-amplify";

export const buildApiHeaders = async () => {
  const headers = { "Content-Type": "application/json" };
  try {
    const session = await Auth.currentSession();
    const idToken = session.getIdToken().getJwtToken();
    if (idToken) headers["Authorization"] = `Bearer ${idToken}`;
  } catch (e) {
    // Not signed in — request goes through anonymous; routes that require
    // auth will respond 401.
  }
  return headers;
};
